var _PhotoAdultFilterCommand_instances, _PhotoAdultFilterCommand_createParam;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
import { SessionService } from '../../service/SessionService';
export class PhotoAdultFilterCommand {
    constructor() {
        _PhotoAdultFilterCommand_instances.add(this);
    }
    async execute(photoHash, adult) {
        const privKey = SessionService.getPrivateKey();
        const host = 'https://mycast.xyz:9011';
        const url = `${host}/photo/${photoHash}/adult`;
        try {
            const { data } = await axios.post(url, __classPrivateFieldGet(this, _PhotoAdultFilterCommand_instances, "m", _PhotoAdultFilterCommand_createParam).call(this, privKey, adult));
            return data && data.result === true;
        }
        catch (e) {
            console.error('unknown error', e);
            return false;
        }
    }
}
_PhotoAdultFilterCommand_instances = new WeakSet(), _PhotoAdultFilterCommand_createParam = function _PhotoAdultFilterCommand_createParam(privKey, adult) {
    const params = new URLSearchParams();
    params.set('user', privKey);
    params.set('msg', adult ? 'true' : 'false');
    return params.toString();
};
